"use strict";

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@8base/utils");

var SubscribableDecorator =
/*#__PURE__*/
function () {
  function SubscribableDecorator() {
    _classCallCheck(this, SubscribableDecorator);
  }

  _createClass(SubscribableDecorator, null, [{
    key: "hasConflicts",
    value: function hasConflicts(authClient) {
      return Reflect.has(authClient, 'publisher') || Reflect.has(authClient, 'subscribe') || Reflect.has(authClient, 'notify') || Reflect.has(authClient, 'batch');
    }
  }, {
    key: "decorate",
    value: function decorate(authClient) {
      var _obj;

      if (SubscribableDecorator.hasConflicts(authClient)) {
        throw new utils_1.SDKError(utils_1.ERROR_CODES.PROPERTY_CONFLICT, utils_1.PACKAGES.AUTH, "authClient has property conflict, it shouldn't have 'publisher', 'subscribe', 'notify' and 'batch' properties");
      }

      var decoratedAuthClient = _obj = {
        publisher: new utils_1.Publisher(),
        subscribe: function subscribe(subscriber) {
          return this.publisher.subscribe(subscriber);
        },
        notify: function notify(state) {
          this.publisher.notify(state);
        },
        batch: function batch(fn) {
          this.publisher.batch(fn);
        },
        setState: function setState(state) {
          _get(_getPrototypeOf(_obj), "setState", this).call(this, state); // @ts-ignore


          var newState = this.getState();
          this.notify(newState);
        },
        purgeState: function purgeState() {
          _get(_getPrototypeOf(_obj), "purgeState", this).call(this); // @ts-ignore


          var newState = this.getState();
          this.notify(newState);
        }
      };
      Object.setPrototypeOf(decoratedAuthClient, authClient); // @ts-ignore

      return decoratedAuthClient;
    }
  }]);

  return SubscribableDecorator;
}();

exports.SubscribableDecorator = SubscribableDecorator;